import {ValidationError} from 'class-validator';


export const getValidationErrorMessages = (errors: ValidationError[]): string => {
  return errors.map(({
                       value,
                       property,
                       constraints
                     }) => `${property} with value ${value}: does not meet: ${constraints && Object.entries(constraints).map(([k, v]) => `${k}: ${v}`).join(',')}`).join(',');
}